export const CERTIFICATIONS = {
  ATTRS_NAME: 'breeder_profile_certifications_attributes',
  INPUT_NAME: 'breeder_certification_attributes',
  INPUT_NAME_ID: 'breeder_certification_id'
};

export const CLUBS = {
  NATIONAL_ATTRS_NAME: 'national_breeder_profile_clubs_attributes',
  LOCAL_ATTRS_NAME: 'local_breeder_profile_clubs_attributes',
  INPUT_NAME: 'breeder_club_attributes',
  INPUT_NAME_ID: 'breeder_club_id'
};

export const PAYOUT_SUCCESS_TITLE = 'All set!';
export const PAYOUT_SUCCESS_COPY = `
  Thanks for adding your payout method. Payments made to you through
  Good Dog will be paid out directly to your payout method.
`;

export const DOB_FIELD_NAME =
  'breeder_profile.billing_profile_attributes.date_of_birth';

export const SNOOZED_REASONS = {
  BREAK: 'Taking a break',
  TOO_MANY_APPLICATIONS: 'Too many applications',
  RETIRED: 'Retired or no longer breeding breed',
  OTHER: 'Other'
};

export const DEFAULT_BUYER_APP_QUESTIONS = [
  'What’s your name? (First and last name)',
  'What’s your email?',
  'What’s your phone number?',
  'Where are you located? (Zip code)',
  'What type of home are you in?',
  'Is there anyone else you live with?',
  'What pets do you have in your household?',
  'What’s your outdoor access like?',
  'Have you owned this breed before?',
  'Will you be the main caretaker? If not, who will be?',
  'Which pick-up options are you interested in? (These options are based on the puppy transportation options you’ve listed on your Good Dog profile)'
  // 'Introduce yourself to BREEDER_NAME' added in EditApplicationPage
];

export const BREEDER_REFUND_POLICY = {
  NON_REFUNDABLE: 'non-refundable',
  REFUNDABLE: 'refundable',
  OTHER: 'other'
};

export const SIGNATURE_REQUEST_STATUSES = {
  PENDING: 'pending',
  PENDING_CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  DECLINED: 'declined',
  CANCELLED: 'cancelled'
};

export const BREEDER_FEE_WAIVE_REASONS = {
  is_off_platform:
    'You referred this buyer, so this transaction is deduction-free.',
  before_fee_effective_date:
    'You connected with this buyer before September 10th, so this transaction is deduction-free.',
  first_fee_waived:
    'For a smooth transition, your first deposit and puppy payment are deduction-free.'
};

export const COVER_PHOTO_POSITIONS = {
  MAIN: 'main',
  TOP: 'top',
  MIDDLE: 'middle',
  BOTTOM: 'bottom'
};

export const DROP_OFF_FEE_TYPES = {
  FLAT_FEE: 'flat_fee',
  PER_MILE: 'per_mile',
  PER_HOUR: 'per_hour',
  OTHER: 'other'
};

export const AVAILABLE_TRANSPORTATION_METHODS = [
  {
    value: 'Me',
    title: 'Me'
  },
  {
    value: 'Family/friend',
    title: 'Family/friend'
  },
  {
    value: 'Trusted transporter',
    title: 'Trusted transporter'
  }
];

export const AVAILABLE_TRANSPORTATION_KEYS =
  AVAILABLE_TRANSPORTATION_METHODS.map(el => el.value);

export const GROUND_TRANSPORT = 'Ground transport';
export const FLIGHT_NANNY = 'Flight nanny';
export const PET_AIR_CARGO = 'Pet air cargo';

export const DROP_OFF_FEE_TYPE_OPTIONS = [
  {
    title: 'Per mile',
    value: DROP_OFF_FEE_TYPES.PER_MILE
  },
  {
    title: 'Per hour',
    value: DROP_OFF_FEE_TYPES.PER_HOUR
  },
  {
    title: 'Flat fee',
    value: DROP_OFF_FEE_TYPES.FLAT_FEE
  },
  {
    title: 'Other',
    value: DROP_OFF_FEE_TYPES.OTHER
  }
];
